import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45c75c0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "team-form-backoffice"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-arrow-left" }, null, -1))
const _hoisted_3 = { class: "ms-2 text-lowercase" }
const _hoisted_4 = { class: "p-4" }
const _hoisted_5 = { class: "row align-items-center" }
const _hoisted_6 = { class: "col-sm-2 col-form-label mb-4 position-label" }
const _hoisted_7 = { class: "col-sm-2 col-5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-sm-1 col-2 mb-4" }, "/", -1))
const _hoisted_9 = { class: "col-sm-7 col-5" }
const _hoisted_10 = { class: "py-2" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-dash-circle-fill text-danger" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-plus-lg" }, null, -1))
const _hoisted_17 = {
  class: "mb-2 ms-2",
  style: {"cursor":"pointer"}
}
const _hoisted_18 = { class: "pb-4 pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MrUiKitButton = _resolveComponent("MrUiKitButton")!
  const _component_MrUiKitSelect = _resolveComponent("MrUiKitSelect")!
  const _component_MrUiKitToggle = _resolveComponent("MrUiKitToggle")!
  const _component_MrUiKitInput = _resolveComponent("MrUiKitInput")!
  const _component_ResultBlockForm = _resolveComponent("ResultBlockForm")!
  const _component_MrUiKitAddField = _resolveComponent("MrUiKitAddField")!
  const _component_MrUiKitMultiUpload = _resolveComponent("MrUiKitMultiUpload")!
  const _component_MrUiKitMultiLanguage = _resolveComponent("MrUiKitMultiLanguage")!

  return (_ctx.isMounted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.hideBack)
          ? (_openBlock(), _createBlock(_component_MrUiKitButton, {
              key: 0,
              onClick: _ctx.onBack,
              classes: ['btn-link', 'text-secondary', 'back-button']
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.t("common.operations.back")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_MrUiKitSelect, {
              modelValue: _ctx.model.competition,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.competition) = $event)),
              items: _ctx.lists.competitions,
              name: "competition",
              onTouch: _ctx.onUpdateFormItem,
              key: "id",
              labelKey: "name",
              label: _ctx.t('results.competition'),
              labelPosition: "left",
              infiniteScroll: true,
              status: _ctx.v$.competition,
              placeholder: _ctx.t('common.placeholders.selectCompetition'),
              count: _ctx.counts.competitions,
              onLoad: _ctx.loadCompetitions
            }, null, 8, ["modelValue", "items", "onTouch", "label", "status", "placeholder", "count", "onLoad"]),
            _createVNode(_component_MrUiKitSelect, {
              modelValue: _ctx.model.sport,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.sport) = $event)),
              items: _ctx.sports,
              key: "id",
              labelKey: "name",
              label: _ctx.t('results.sport'),
              status: _ctx.v$.sport,
              labelPosition: "left",
              placeholder: _ctx.t('common.placeholders.sport'),
              name: "sport",
              onTouch: _ctx.onUpdateFormItem
            }, null, 8, ["modelValue", "items", "label", "status", "placeholder", "onTouch"]),
            _createVNode(_component_MrUiKitSelect, {
              modelValue: _ctx.model.discipline,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.discipline) = $event)),
              items: _ctx.disciplines,
              key: "id",
              labelKey: "name",
              label: _ctx.t('results.discipline'),
              labelPosition: "left",
              status: _ctx.v$.discipline,
              placeholder: _ctx.t('common.placeholders.discipline'),
              name: "discipline",
              onTouch: _ctx.onUpdateFormItem
            }, null, 8, ["modelValue", "items", "label", "status", "placeholder", "onTouch"]),
            _createVNode(_component_MrUiKitSelect, {
              modelValue: _ctx.model.organizations,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.organizations) = $event)),
              items: _ctx.lists.organizations,
              key: "id",
              labelKey: "fullname",
              label: _ctx.t('results.organizations'),
              labelPosition: "left",
              status: _ctx.v$.organizations,
              infiniteScroll: true,
              multiple: true,
              count: _ctx.counts.organizations,
              onLoad: _ctx.loadOrganizations,
              name: "organizations",
              onTouch: _ctx.onUpdateFormItem
            }, null, 8, ["modelValue", "items", "label", "status", "count", "onLoad", "onTouch"]),
            _createVNode(_component_MrUiKitSelect, {
              modelValue: _ctx.model.trainers,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.trainers) = $event)),
              items: _ctx.lists.trainers,
              key: "id",
              labelKey: "fullname",
              label: _ctx.t('results.trainers'),
              labelPosition: "left",
              status: _ctx.v$.trainers,
              infiniteScroll: true,
              multiple: true,
              count: _ctx.counts.trainers,
              onLoad: _ctx.loadTrainers,
              name: "trainers",
              onTouch: _ctx.onUpdateFormItem
            }, null, 8, ["modelValue", "items", "label", "status", "count", "onLoad", "onTouch"]),
            _createVNode(_component_MrUiKitSelect, {
              modelValue: _ctx.model.tags,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.tags) = $event)),
              items: _ctx.lists.tags,
              key: "id",
              labelKey: "name",
              label: "Tag",
              labelPosition: "left",
              infiniteScroll: true,
              multiple: true,
              count: _ctx.counts.tags,
              onLoad: _ctx.loadTags
            }, null, 8, ["modelValue", "items", "count", "onLoad"]),
            _createVNode(_component_MrUiKitSelect, {
              modelValue: _ctx.model.athletes,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.athletes) = $event)),
              items: _ctx.lists.athletes,
              status: _ctx.v$.athletes,
              key: "id",
              labelKey: "fullname",
              label: _ctx.t('results.athletes'),
              labelPosition: "left",
              infiniteScroll: true,
              multiple: true,
              count: _ctx.counts.athletes,
              onLoad: _ctx.loadAthletes,
              name: "athletes",
              onTouch: _ctx.onUpdateFormItem
            }, null, 8, ["modelValue", "items", "status", "label", "count", "onLoad", "onTouch"]),
            _createVNode(_component_MrUiKitToggle, {
              modelValue: _ctx.model.isOrganizationResult,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.isOrganizationResult) = $event)),
              label: _ctx.t('results.resultCategory'),
              labelPosition: "left",
              mode: 'tab',
              items: _ctx.toggleIsOrganizationItems
            }, null, 8, ["modelValue", "label", "items"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t("result.position")), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_MrUiKitInput, {
                  modelValue: _ctx.model.position,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.position) = $event)),
                  status: _ctx.v$.position,
                  name: "position",
                  onTouch: _ctx.onUpdateFormItem,
                  placeholder: _ctx.t('common.placeholders.position')
                }, null, 8, ["modelValue", "status", "onTouch", "placeholder"])
              ]),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_MrUiKitInput, {
                  modelValue: _ctx.model.totPartecipant,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.totPartecipant) = $event)),
                  placeholder: _ctx.t('common.placeholders.totPartecipant')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _createVNode(_component_ResultBlockForm, {
              text: _ctx.entityResultText,
              modelValue: _ctx.generalIntermiadiate,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.generalIntermiadiate) = $event)),
              status: _ctx.v$['competitionResultType'],
              onTouch: _ctx.onUpdateFormItem
            }, null, 8, ["text", "modelValue", "status", "onTouch"]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_MrUiKitAddField, {
                modelValue: _ctx.model.intermiadiates,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.model.intermiadiates) = $event)),
                template: _ctx.intermiadiateTemplate,
                fieldClasses: ['d-flex']
              }, {
                default: _withCtx(({ index }) => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_ResultBlockForm, {
                      text: _ctx.entityResultText,
                      modelValue: _ctx.model.intermiadiates[index],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.model.intermiadiates[index]) = $event)
                    }, null, 8, ["text", "modelValue", "onUpdate:modelValue"])
                  ])
                ]),
                "button-remove": _withCtx(({ click }) => [
                  _createElementVNode("div", {
                    class: "mt-n2 ms-3 button-remove",
                    onClick: click
                  }, _hoisted_14, 8, _hoisted_12)
                ]),
                "button-add": _withCtx(({ click }) => [
                  _createElementVNode("div", {
                    onClick: click,
                    class: "text-primary button-add"
                  }, [
                    _hoisted_16,
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.t("common.operations.addIntermiadiate")), 1)
                  ], 8, _hoisted_15)
                ]),
                _: 1
              }, 8, ["modelValue", "template"])
            ]),
            _createVNode(_component_MrUiKitMultiUpload, {
              class: "pt-4",
              onUpload: _ctx.onUpload,
              modelValue: _ctx.model.attachments,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.attachments) = $event)),
              label: "Attachments"
            }, null, 8, ["onUpload", "modelValue"]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_MrUiKitMultiLanguage, {
                type: "texteditor",
                modelValue: _ctx.model.generalNotes,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.model.generalNotes) = $event)),
                label: _ctx.t('common.notes'),
                labelPosition: "left",
                languages: _ctx.languages,
                currentLanguage: _ctx.currentLanguage
              }, null, 8, ["modelValue", "label", "languages", "currentLanguage"])
            ]),
            _createVNode(_component_MrUiKitButton, {
              type: "submit",
              disabled: _ctx.v$.$invalid,
              classes: ['ms-2', 'btn-primary', 'float-end']
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("common.operations.save")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ], 32)
        ])
      ]))
    : _createCommentVNode("", true)
}